import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, TextValue } from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';

export class TextHandler implements IQueryConditionHandler {
  convert(qc: QueryCondition) {
    const tv = (qc.value as TextValue);
    return [{
      'FilterField': qc.fieldCode,
      'Compare': (qc.compareType || qc.compareType === 0) ? qc.compareType : CompareType.Like,
      'Value': tv.value, // jsonè½¬ä¹ä¸encodeUriComponentä¸åï¼ä¸åºå¨æ­¤è½¬ä¹ï¼ç±jsonåé¨è½¬ä¹å³å¯
      'Relation': (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And,
      'Expresstype': ValueType.Value,
      'Lbracket': qc.Lbracket || null,
      'Rbracket': qc.Rbracket || null
    }];
  }
}
